import { formatSizeRange, propertyNoteKey } from '../../domain/plants/plantProperties';

/**
 * A decision property, in words (SPEC-024 D-6).
 *
 * Size is the one property whose value is a measurement rather than one of a
 * handful of named values, so it is composed here instead of looked up. That
 * exception is the whole reason this module exists: the plate below the fold and
 * the three glances above it both need it, and a copy in each is two places for
 * a centimetre to become a metre.
 *
 * `t` is passed in rather than a hook called: this is presentation text, and the
 * callers already hold the locale.
 */

/** "Low to moderate", or "15–25 m" for the one that is a measurement. */
export function propertyValue(t, plant, property) {
    const detail = plant.properties[property];

    return property === 'size' ? formatSizeRange(detail) : t(detail.labelKey);
}

/**
 * The same value in the short vocabulary — "Medium", "Sun or shade", "Any soil".
 *
 * `.short` is what the filter tiles print (`plantFilters.js`), so the compact row
 * on the first screen and the tile a reader filtered with say the same word. Size
 * has no short form and needs none: a range is already three characters and a
 * unit.
 */
export function propertyShortValue(t, plant, property) {
    const detail = plant.properties[property];

    return property === 'size' ? formatSizeRange(detail) : t(`${detail.labelKey}.short`);
}

/** The one plain sentence under that value (SPEC-003 D-1). */
export function propertyNote(t, plant, property) {
    const detail = plant.properties[property];

    if (property !== 'size') {
        return t(propertyNoteKey(detail.labelKey));
    }

    return t('plants.detail.sizeNote', {
        height: formatSizeRange(detail),
        spread: formatSizeRange(plant.spread ?? detail),
    });
}
